/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListUserApiKeyExtensionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {ListUserApiKeyExtensionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const listUserApiKeyExtensions = (request: ListUserApiKeyExtensionsRequest, options?: CashRequestOptions) => post<ListUserApiKeyExtensionsRequest, ListUserApiKeyExtensionsResponse>("/2.0/cash/list-user-api-key-extensions", request, {...options, rejectOnError: true })